export default __webpack_public_path__ + "static/media/vide-noir.77bd86ba.jpg";